var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visibleCategories && _vm.visibleCategories.length > 0
    ? _c("section", { staticClass: "offers container my30" }, [
        _c(
          "div",
          { staticClass: "row" },
          _vm._l(_vm.visibleCategories, function(link, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "offer-container col-xs-12 col-sm-12 pb15"
              },
              [
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: _vm.localizedRoute({
                        name: "category",
                        params: { id: link.id, slug: link.url_path }
                      })
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "lazy",
                            rawName: "v-lazy:background-image",
                            value: link.image,
                            expression: "link.image",
                            arg: "background-image"
                          }
                        ],
                        staticClass: "offer"
                      },
                      [
                        _c("h3", { staticClass: "title m0 h1" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(link.name) +
                              "\n          "
                          )
                        ])
                      ]
                    )
                  ]
                )
              ],
              1
            )
          }),
          0
        )
      ])
    : _vm.config.rootcategories.drukowanie === _vm.$route.meta.category &&
      _vm.visibleCategories
    ? _c("section", { staticClass: "offers container my30 px15" }, [
        _c(
          "div",
          { staticClass: "row" },
          [
            _vm._l(_vm.banners.mainBanners, function(banner, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "offer-container col-xs-12 col-sm-12 pb15"
                },
                [
                  _c(
                    "router-link",
                    { attrs: { to: _vm.localizedRoute(banner.link) } },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "lazy",
                              rawName: "v-lazy:background-image",
                              value: banner.image,
                              expression: "banner.image",
                              arg: "background-image"
                            }
                          ],
                          staticClass: "offer"
                        },
                        [
                          _c("h3", { staticClass: "title m0 h1" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(banner.title) +
                                "\n          "
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12" },
              _vm._l(_vm.banners.smallBanners, function(banner, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "offer-container pb15" },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: _vm.localizedRoute(banner.link) } },
                      [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "lazy",
                                rawName: "v-lazy:background-image",
                                value: banner.image,
                                expression: "banner.image",
                                arg: "background-image"
                              }
                            ],
                            staticClass: "offer"
                          },
                          [
                            _c("h3", { staticClass: "title m0 h1" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(banner.title) +
                                  "\n            "
                              )
                            ])
                          ]
                        )
                      ]
                    )
                  ],
                  1
                )
              }),
              0
            )
          ],
          2
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }